import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import * as C from "components";

const useStyles = makeStyles({
  loaderBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderBarImg: {
    width: 40,
  },
  tableContainer: {
    display: "flex",
    minHeight: 200,
  },
  dateTableWrapper: {
    float: "left",
  },
  dataTableWrapper: {
    float: "left",
    overflow: "scroll",
  },
  leftTable: {
    border: "1px solid #eee",
    tableLayout: "fixed",
  },
  lblGameName: {
    color: "#000",
    fontSize: 13,
    wordBreak: "break-word",
    minWidth: 200,
  },
  lblUniqueUser: {
    color: "#6f6969",
    fontSize: 11,
    minWidth: 180,
  },
  _GAIv: {
    height: 40,
    backgroundColor: "#4#4#4",
    borderLeft: "1px solid #eee6e6",
    color: "#666",
    fontSize: 11,
    minWidth: 80,
    paddingRight: 10,
    textAlign: "right",
  },
  dataHeaderTd: {
    width: 100,
    paddingRight: 10,
    borderBottom: "1px solid #eee6e6",
  },
  dataTableBody: {
    fontSize: 11,
    paddingRight: 10,
    paddingBottom: 0,
    textAlign: "right",
    verticalAlign: "middle",
    border: "1px solid #eee6e6",
    height: "3em",
    overflowX: "auto",
  },
  dataCellTd: {
    verticalAlign: "top",
    fontSize: 13,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
    textAlign: "right",
    verticalAlign: "middle",
    borderBottom: "1px solid #eee6e6",
    borderRight: "1px solid #eee6e6",
    height: 45,
  },
  tTdHeader: {
    paddingLeft: "1rem",
    paddingRight: 19,
    fontWeight: "bold",
    height: 39,
  },
  tTd: {
    minWidth: 240,
    maxWidth: 260,
    padding: "0.5rem 1rem",
    borderBottom: "1px solid #eee",
    verticalAlign: "top",
    wordBreak: "break-word",
  },
  tableNumberData: {
    fontSize: 13,
    paddingBottom: 4,
  },
  exportBtn: {
    marginLeft: 16,
  },
  titleContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  widgetTitle: {
    flexBasis: "50%",
    fontSize: 16,
    padding: 16,
  },
  exportBtnContainer: {
    marginLeft: "auto",
    padding: 16,
  },
});

const PicTreeMissionDataTable = ({
  title,
  dataByDate,
  loading,
  noDataText,
  exportTitle,
  legend,
}) => {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(dataByDate);
  }, [dataByDate]);

  useEffect(() => {
    const leftRows = document.querySelectorAll(".left-table-row");
    const rightRows = document.querySelectorAll(".right-table-row");

    if (leftRows.length !== rightRows.length) return;

    for (let i = 0; i < leftRows.length; i++) {
      const left = leftRows[i];
      const right = rightRows[i];

      const leftHeight = left instanceof HTMLElement ? left.clientHeight : 0;
      const rightHeight = right instanceof HTMLElement ? right.clientHeight : 0;
      const maxHeight = Math.max(leftHeight, rightHeight);

      if (left instanceof HTMLElement) left.style.height = `${maxHeight}px`;
      if (right instanceof HTMLElement) right.style.height = `${maxHeight}px`;
    }
  }, [tableData]);

  const getTableColumnName = (tableData) => {
    const columnName = Object.keys(tableData[0]).filter(k => k !== 'date');
    return (
      <Fragment>
        {columnName.map((name, i) => (
          <tr className="left-table-row" key={i}>
            <td className={classes.tTd}>
              <div className={classes.lblGameName}>
                {name}
              </div>
            </td>
          </tr>
        ))}
      </Fragment>
    );
  };

  const getDataHeader = (dataByDate) => {
    return (
      <Fragment>
        <tr className={classes._GAIv}>
          {dataByDate[0]["date"].map((item, i) => (
            <td className={classes.dataHeaderTd} key={i}>
              {moment(item).format("M/D")}
            </td>
          ))}
        </tr>
      </Fragment>
    );
  };

  const getDataTable = (tableData) => {
    const keys = Object.keys(tableData[0]);
    return (
      <>
        {keys.map((key, i) => (
          key !== "date" &&
          <tr className="right-table-row" key={i} style={{backgroundColor: key.indexOf("Ratio") !== -1 ? "#e9ebee" : "#FFF"}}>
            {tableData[0][key].map((value, index) => (
              <td key={index} className={classes.dataCellTd}>
                {value}
              </td>
            ))}
          </tr>
        ))}
      </>
    );
  };

  const getExportData = (data) => {
    const exportData = [];

    if (!data || !data.length || !data[0].date) return exportData;

    const quizKeys = Object.keys(data[0]).filter(k => k !== "date");
    const dates = data[0].date.map(d => moment(d).format("M/D")); // UIと同じ日付形式

    // ヘッダー: ["クイズ名", "3/21", "3/22", ...]
    exportData.push([legend, ...dates]);

    quizKeys.forEach((quizKey) => {
      const row = [quizKey, ...data[0][quizKey]];
      exportData.push(row);
    });

    return exportData;
  };


  return (
    <Paper>
      <div className={classes.titleContainer}>
        <div className={classes.widgetTitle}>{title}</div>
        <div className={classes.exportBtnContainer}>
          {tableData[0] !== undefined && tableData[0]["date"].length > 0 && (
            <CSVLink data={getExportData(tableData)} filename={exportTitle}>
              <Button
                variant="contained"
                color="default"
                className={classes.exportBtn}
                startIcon={<GetApp />}
              >
                CSV出力
              </Button>
            </CSVLink>
          )}
        </div>
      </div>
      <div className={classes.tableContainer}>
        {loading ? (
          <div className={classes.loaderBox}>
            <img
              className={classes.loaderBarImg}
              src={`/static/images/loader-bar.gif`}
            />
          </div>
        ) : tableData[0] && tableData[0]["date"].length > 0 ? (
          <Fragment>
            <div className={classes.dateTableWrapper}>
              <table className={classes.leftTable}>
                <tbody>
                  <tr>
                    <td className={classes.tTdHeader}></td>
                  </tr>
                  {getTableColumnName(tableData)}
                </tbody>
              </table>
            </div>

            <div className={classes.dataTableWrapper}>
              <table className={classes.dataTableBody}>
                <tbody>
                  {getDataHeader(tableData)}
                  {getDataTable(tableData)}
                </tbody>
              </table>
            </div>
          </Fragment>
        ) : (
          <div className={classes.loaderBox}>
            <C.NoData text={"データ取得中..."} />
          </div>
        )}
      </div>
    </Paper>
  );
};

PicTreeMissionDataTable.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  // dataByDate: state.pictree.missionDailyUsersById,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PicTreeMissionDataTable);
